module.exports = __webpack_public_path__ + "img/4.0deb75dc.png";